var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLumberIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11861",
    "data-name": "Group 11861",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.104,
    height: 23.949,
    viewBox: "0 0 17.104 23.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4232",
    "data-name": "Rectangle 4232",
    width: 17.104,
    height: 23.949,
    fill: "#393939"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11826",
    "data-name": "Group 11826",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M17.1,12.03c0,3.109.009,6.218-.005,9.327a2.523,2.523,0,0,1-1.287,2.259,2.636,2.636,0,0,1-1.388.329q-5.866.006-11.733,0A2.563,2.563,0,0,1,.126,22.112a2.992,2.992,0,0,1-.12-.842Q0,11.916,0,2.562A2.469,2.469,0,0,1,1.344.317,2.632,2.632,0,0,1,2.682.006C6.624,0,10.566.013,14.508,0a2.581,2.581,0,0,1,2.518,1.974,3.376,3.376,0,0,1,.072.715q.007,4.67,0,9.341M1.707,11.977v9.206c0,.053,0,.107,0,.16a.866.866,0,0,0,.8.882,2.023,2.023,0,0,0,.28.016H14.356c.053,0,.107,0,.16,0a.857.857,0,0,0,.835-.645,1.777,1.777,0,0,0,.042-.423q0-9.18,0-18.359c0-.076,0-.152-.005-.227a.856.856,0,0,0-.639-.826,1.814,1.814,0,0,0-.436-.044q-3.822,0-7.643,0-2,0-4,0a.933.933,0,0,0-.8.37,1.108,1.108,0,0,0-.165.689q0,4.6,0,9.206",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M53.108,48.015c1.1,0,2.191.01,3.286,0a1.7,1.7,0,0,1,1.656,1.12,1.792,1.792,0,0,1,.113.664q.019,1.215,0,2.431a1.714,1.714,0,0,1-.887,1.556,1.826,1.826,0,0,1-.927.213q-3.333,0-6.666,0a1.729,1.729,0,0,1-1.735-1.409,2.4,2.4,0,0,1-.04-.438c0-.77.022-1.542-.008-2.311a1.725,1.725,0,0,1,1.825-1.824q1.69,0,3.38,0m3.345,1.715H49.625v2.557h6.828Z",
    transform: "translate(-44.488 -44.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M168.111,158.532c0-.392,0-.783,0-1.175a.866.866,0,0,1,.641-.879.828.828,0,0,1,1.022.681,4.187,4.187,0,0,1,.026.451c0,.707.005,1.415,0,2.122a.9.9,0,0,1-.352.77.785.785,0,0,1-.82.095.75.75,0,0,1-.485-.667c-.022-.465-.006-.932-.006-1.4h-.026",
    transform: "translate(-156.129 -145.3)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M49.6,158.044a5.171,5.171,0,0,1-.569-.061.811.811,0,0,1-.644-.822.785.785,0,0,1,.676-.779,5.2,5.2,0,0,1,1.179.009.811.811,0,0,1,.669.818.854.854,0,0,1-.74.794c-.176.023-.354.026-.572.041",
    transform: "translate(-44.937 -145.209)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M109.6,158.045a5.2,5.2,0,0,1-.567-.062.811.811,0,0,1-.641-.824.786.786,0,0,1,.678-.777,5.217,5.217,0,0,1,1.179.01.811.811,0,0,1,.666.82.854.854,0,0,1-.742.792c-.176.023-.354.026-.573.041",
    transform: "translate(-100.662 -145.21)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M49.593,206.046a5.179,5.179,0,0,1-.567-.062.811.811,0,0,1-.641-.824.786.786,0,0,1,.679-.777,5.211,5.211,0,0,1,1.179.011.81.81,0,0,1,.665.82.854.854,0,0,1-.743.791c-.176.023-.354.026-.574.041",
    transform: "translate(-44.937 -189.79)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M109.592,205.7a5.272,5.272,0,0,1-.567-.063.819.819,0,0,1,.044-1.606,3.27,3.27,0,0,1,1.18.011.852.852,0,0,1,.664.816.865.865,0,0,1-.735.8c-.18.024-.363.027-.586.042",
    transform: "translate(-100.662 -189.446)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M49.592,253.7a5.262,5.262,0,0,1-.568-.062.819.819,0,0,1,.041-1.606,3.262,3.262,0,0,1,1.18.01.852.852,0,0,1,.665.815.865.865,0,0,1-.733.8c-.18.025-.363.027-.586.042",
    transform: "translate(-44.937 -234.024)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M109.595,254.046a5.18,5.18,0,0,1-.567-.062.811.811,0,0,1-.641-.824.786.786,0,0,1,.678-.777,5.213,5.213,0,0,1,1.179.011.81.81,0,0,1,.666.82.854.854,0,0,1-.743.791c-.176.023-.354.026-.574.041",
    transform: "translate(-100.662 -234.369)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M169.932,241.788a3.882,3.882,0,0,1-.065.565.818.818,0,0,1-1.61-.141,5.983,5.983,0,0,1,0-1.034.8.8,0,0,1,.844-.709.822.822,0,0,1,.79.758c.019.167.023.336.038.56",
    transform: "translate(-156.246 -223.331)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumberIcon);
export default __webpack_public_path__ + "static/media/lumber-icon.8349c1ebe3b570fa6e960ecc0c41b2f2.svg";
export { ForwardRef as ReactComponent };